import { Button, Popconfirm, PopconfirmProps, notification } from "antd";
import { ReactNode } from "react";
import { useNotaCancelar } from "../../../../../Services/Financeiro/Titulo/NotaService";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import Nota from "../../../../../Models/Financeiro/Titulo/Nota";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
interface ICancelamentoPopconfirmProps extends Omit<PopconfirmProps, "children" | "title"> {
    nota:Nota;
    children?:ReactNode;
    title?: React.ReactNode | (() => React.ReactNode);
    onSuccess?:() => void;
}
export default function NotaCancelamentoPopconfirm({
    nota,
    children,
    title,
    description,
    onSuccess,
    ...rest
}:ICancelamentoPopconfirmProps) {
    title = title ?? "Cancelar nota";
    description = description ?? "Tem certeza de que deseja cancelar esta nota?";

    const {
        mutate,
        isPending
    } = useNotaCancelar({
        onSuccess() {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Nota cancelada com sucesso."
            });

            onSuccess?.();
        },
    });
    return <ComponentePermissao permissoes={["FinanceiroTituloNotaCancelar"]}>
        <Popconfirm
            {...rest}
            title={title}
            description={description}
            onConfirm={() => {
                mutate(nota.codigo);
            }}
            destroyTooltipOnHide={false}
        >
            {children || <Button
                type='primary'
                loading={isPending}
                danger
                size='small'
            >Cancelar</Button>}
        </Popconfirm>
    </ComponentePermissao>;
}